module.exports = __webpack_public_path__ + "img/6.d2e5dc9f.png";